import axios from '../../../../api/axios';
import React,{useState,useEffect} from 'react'
import Swal from 'sweetalert2';
import {useParams,useNavigate} from 'react-router-dom'
import { isEmpty } from '../../../../Utilities/Utils';
import { useAuth } from '../../../../ContextApp/AuthContext';

function Update(){

    const {user}=useAuth()
    const {id}=useParams()
    const navigate=useNavigate()
    const [enseignants,setEnseignants]=useState([]);
    const [titulaire,setTitulaire]=useState("")
    const [encadreur,setEncadreur]=useState("")
    const records=enseignants.filter(enseign=>enseign.idenseignant!=titulaire?.idenseignant)
    useEffect(()=>{
        HanleRequest()
        HandleRequestTitulaire()
    },[])
    const HanleRequest=async(e)=>{
        await axios.post('api/Classetitulaire',{idclasse:id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
          setTitulaire(res.data.titulaire[0])  
         
        }).catch((err)=>{
            console.log(err)
        })
    }
    console.log(titulaire)
    const HandleRequestTitulaire=async(e)=>{
        await axios.post(`api/classeenseignants/${id}`,{annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
                setEnseignants(res.data.enseignants)
        }).catch((err)=>{
            console.log(err)
        })
    }
    function confirmSave(e){
        e.preventDefault()
        if(!isEmpty(titulaire)){
        Swal.fire({
            title:'Demande de confirmation',
            text:'Voulez-vous vraiment modifier le titulaire de cette classe ?',
            icon:'question',
            showCancelButton:true,
            showConfirmButton:true,
            confirmButtonText:'Confirmer',
        }).then((resultat)=>{
            if(resultat.isConfirmed){
                HandleSubmit()
            }
        })  
        }
        else{
            Swal.fire({
                title:'Erreur de soumission',
                text:'Veuillez d\'abord sélectionner le nouveau titulaire',
                icon:'warning'
            })
        }
    }
    const HandleSubmit=async (e)=>{
       
                await axios.put(`api/Titulariat/${titulaire?.id}`,{idenseignant:encadreur,idclasse:id,idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then((res)=>{
                    if(res.data.status_code===205){
                        Swal.fire({
                            title:'Message de confirmation',
                            text:'Le nouveau titulaire a été ajouté avec succès',
                            icon:'success',
                            
                        }).then((res)=>{
                            
                        })
                        navigate('/classe')
                    }
                    else{
                        Swal.fire({
                            title:'Message d\'erreur',
                            text:res.data.message,
                            icon:'error'
                            
                        })
                    }
                    console.log(res)
                     
                }).catch((err)=>{
                        document.getElementById("erreur").innerHTML=err
                        
                        
                })
    }
    return(
    <>
        <div className="container py-5">
    <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-5">
            {/* Carte de modification stylisée */}
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                
                {/* En-tête avec une icône distinctive */}
                <div className="card-header bg-white border-0 pt-4 pb-0 text-center">
                    <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '60px', height: '60px'}}>
                        <i className="bi bi-person-badge text-primary fs-3"></i>
                    </div>
                    <h3 className="h5 fw-bold text-dark mb-1">Assignation du Titulaire</h3>
                    <p className="text-muted small">Choisissez l'enseignant responsable de cette classe</p>
                </div>

                <div className="card-body p-4 p-md-5">
                    <form className="form">
                        {/* Sélecteur avec icône */}
                        <div className="mb-4">
                            <label htmlFor="enseignant" className="form-label fw-semibold text-secondary small text-uppercase tracking-wider">
                                Enseignant disponible
                            </label>
                            <div className="input-group shadow-sm">
                                <span className="input-group-text bg-light border-end-0">
                                    <i className="bi bi-search text-muted small"></i>
                                </span>
                                <select 
                                    name="enseignant" 
                                    id="enseignant" 
                                    className="form-select form-select-lg border-start-0 fs-6 shadow-none" 
                                    onChange={(e) => setEncadreur(e.target.value)} 
                                    value={encadreur}
                                    required
                                >
                                    <option value="" disabled>Sélectionnez un nom...</option>
                                    {records.map(record => (
                                        <option key={record.idenseignant} value={record.idenseignant}>
                                            {record.nom_complet}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Bouton d'action principal */}
                        <div className="d-grid gap-2">
                            <button 
                                className="btn btn-primary btn-lg shadow-sm rounded-pill py-3 fw-bold transition-all" 
                                type="button" 
                                onClick={confirmSave}
                            >
                                <i className="bi bi-check2-circle me-2"></i> Valider la modification
                            </button>
                            
                            <button 
                                type="button" 
                                className="btn btn-link btn-sm text-decoration-none text-muted"
                                onClick={() => navigate('/Classes')}
                            >
                                Annuler
                            </button>
                        </div>
                    </form>
                </div>

                {/* Footer discret pour l'info */}
                <div className="card-footer bg-light border-0 py-3 text-center">
                    <span className="text-muted small">
                        <i className="bi bi-info-circle me-1"></i> 
                        Cette action mettra à jour le titulaire immédiatement.
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

    </>
    )
}
export default Update